import { maskitoRejectEvent } from '@maskito/kit';
import { useMaskito } from '@maskito/react';
import { mergeRefs } from '@react-aria/utils';
import { useTextField, mergeProps } from 'react-aria';
import { mergeMaskitoOptions } from '../maskito/merge-maskito-options.js';
import { useOnReject } from '../maskito/use-on-reject.js';

/**
 * Hook for building an accessible text input element.
 *
 * @param props - Options for the hook.
 * @param ref - A ref to the underlying HTML element.
 */ function useTextInput(props, ref) {
    const { disabled, mask, onChange, onInputRejected, validity, required, readOnly, ...rest } = props;
    const { pattern, ...maskOptions } = mask ?? {};
    useOnReject(()=>ref.current && onInputRejected?.(ref.current.value), ref);
    const textFieldProps = {
        ...rest,
        isDisabled: disabled,
        isRequired: required,
        isReadOnly: readOnly,
        isInvalid: validity === 'invalid',
        label: true,
        onChange
    };
    const { inputProps } = useTextField(textFieldProps, ref);
    const maskitoOptions = mergeMaskitoOptions({
        mask: pattern ?? /.*/,
        plugins: ref.current ? [
            maskitoRejectEvent(ref.current)
        ] : []
    }, maskOptions);
    const maskRef = useMaskito({
        options: maskitoOptions
    });
    return mergeProps(inputProps, {
        ref: mergeRefs(ref, maskRef),
        onInput: (event)=>{
            inputProps?.onChange?.(event);
        }
    });
}

export { useTextInput };
//# sourceMappingURL=use-text-input.js.map
